import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import { api } from "../lib/api";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";

export default function PaymentSuccess() {
  const [search] = useSearchParams();
  const nav = useNavigate();
  const sessionId = search.get("session_id");
  const campaignId = search.get("campaign_id");
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let alive = true;
    const poll = async (n) => {
      if (!alive) return;
      if (n > 12) { setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/checkout-status/${sessionId}`);
        setAttempts(n);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(() => poll(n + 1), 2000);
      } catch (e) {
        setTimeout(() => poll(n + 1), 2500);
      }
    };
    poll(0);
    return () => { alive = false; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[var(--rl-bg-subtle)]" data-testid="payment-success-page">
      <Navigation />
      <div className="max-w-md mx-auto px-6 py-20 text-center">
        {status === "checking" && (
          <>
            <Loader2 className="w-10 h-10 text-[var(--rl-brand)] mx-auto animate-spin" />
            <h1 className="font-display font-black text-3xl mt-6">Confirming your payment…</h1>
            <p className="text-[var(--rl-text-secondary)] mt-2">Attempt {attempts + 1}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-[var(--rl-success)] mx-auto" />
            <h1 className="font-display font-black text-3xl mt-6">Campaign launched.</h1>
            <p className="text-[var(--rl-text-secondary)] mt-3 leading-relaxed">Your campaign is now active. Internal panelists are being notified and a Programmatic Panel project is being provisioned for external participant routing.</p>
            <Link to={`/client/campaigns/${campaignId}`} className="inline-block mt-6 bg-[var(--rl-text)] text-white px-5 py-3 font-semibold hover:bg-[var(--rl-brand)] transition-colors" data-testid="goto-campaign-btn">View Live Pulse</Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <AlertTriangle className="w-10 h-10 text-[var(--rl-accent)] mx-auto" />
            <h1 className="font-display font-black text-3xl mt-6">We couldn't confirm payment.</h1>
            <p className="text-[var(--rl-text-secondary)] mt-3 leading-relaxed">Please return to your dashboard. If you were charged, your campaign will appear active shortly.</p>
            <button onClick={() => nav("/client")} className="mt-6 bg-[var(--rl-text)] text-white px-5 py-3 font-semibold">Back to dashboard</button>
          </>
        )}
      </div>
    </div>
  );
}
